import React from 'react'
import './joinus.scss'

function JoinUs() {
  return (
    <div className="mb__join section__padding">
        <p>BANGUN KARAKTER ANAK ANDA SEKARANG</p>
        <button>HUBUNGI KAMI</button>
    </div>
  )
}

export default JoinUs